import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { JardinModel } from 'src/app/model/Jardin.model';
import { ResultadoSeicep } from 'src/app/model/ResultadoSeicep';
import { Evaluacion, Pregunta } from 'src/app/model/evaluacion';
import { apiService } from 'src/app/service/api.service';
import { Seicep2025Service } from 'src/app/service/seicep2025.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-seicep-resultados2025',
  templateUrl: './seicep-resultados2025.component.html',
  styleUrls: ['./seicep-resultados2025.component.css']
})
export class SeicepResultados2025Component implements OnInit {

  @ViewChild('modalInforme', { static: true }) modalInforme: TemplateRef<any>;
  @ViewChild('stepper') stepper !: MatStepper;
  public isCollapsedComponente1 = true;
  public isCollapsedComponente2 = true;
  public isCollapsedComponente3 = true;
  evaluacion : Evaluacion = new Evaluacion();
  resultados : ResultadoSeicep = new ResultadoSeicep();
  titulo: string = '';
  miClaseDinamica: string = '';
  lastQuestion : boolean;
  dataJardin = new JardinModel();
  url:string ;
  urlSafe: SafeResourceUrl;
  apiEndpoint = environment.apiEndpoint;
  showDetail : boolean = true;
  
  constructor(
    private api: apiService,
    private spinner: NgxSpinnerService,
    private modal: NgbModal,
    public sanitizer: DomSanitizer,
    private seicep2025Service: Seicep2025Service,
  ) { }

  ngOnInit(): void {
    this.dataJardin = this.api.dataJardin;
    this.spinner.show();
    this.seicep2025Service.getResultados(this.dataJardin.rbd).subscribe({
      next: (response) => {
        this.showDetail = true;
        this.resultados = response;
        this.spinner.hide();
      },
      error: (error) => {
        this.showDetail = false;
        this.spinner.hide();
      },
    });
    this.seicep2025Service.getEvaluacion(this.dataJardin.rbd).subscribe({
      next: (response) => {
        this.evaluacion = response;
        this.actualizarTitulo(this.evaluacion.preguntas[0]);
        this.spinner.hide();
      },
      error: (error) => {
        this.spinner.hide();
      },
    });

  }


  onSelectionChange(event: any) {
    const preguntaSeleccionada = this.evaluacion.preguntas[event.selectedIndex];
    this.onPreguntaChanged(preguntaSeleccionada);
  }

  onPreguntaChanged(pregunta: Pregunta) {
    this.actualizarTitulo(pregunta); 
  }

  actualizarTitulo(pregunta: Pregunta) {

    switch (pregunta.dimension) {
      case 1:
        this.titulo = 'I.	GESTIÓN PEDAGÓGICA';
        this.miClaseDinamica = "header-background1";
        break;
      case 2:
        this.titulo = 'II.	LIDERAZGO';
        this.miClaseDinamica = "header-background2";
        break;
      case 3:
        this.titulo = 'III.	FAMILIA Y COMUNIDAD';
        this.miClaseDinamica = "header-background3";
        break;
      default:
        this.titulo = '';
    }

  }
  
  
  getStepLabel(pregunta: any): string {
    // Obtener el índice de la pregunta actual
    const index = this.evaluacion.preguntas.indexOf(pregunta);
    // Devolver el número del paso (agregando 1 ya que los índices comienzan desde 0)
    return (index + 1).toString();
  }

  replaceNewlines(text: string): string {
    return text.replace(/\n/g, '<br>');
  }


  imprimir(){
    //console.log("assaas " + this.dataJardin.rbd);
    this.url = this.apiEndpoint + "seicep2025/descargarCertificado/" + this.dataJardin.rbd;
    //console.log("ur: " + this.url);
    this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    this.modal.open(this.modalInforme, { size: 'xl' });
  }

  close(){
    this.modal.dismissAll();
  }

}

